import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Dropdown, Form, Input, Menu, Row } from "antd";

import userAuthApi from "../../apis/UserAuth.api";
import { setMenu, setUser } from "../../redux/store/auth/authDuck";
import { setLoading } from "../../redux/store/common/commonDuck";
import FaqComponent from "../page/salesManage/FaqComponent";

const HeaderComponent = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  // const [error, setError] = useState("");

  const brandList = (
    <Menu>
      {user &&
        user.role !== "super_admin" &&
        user.brandList &&
        user.brandList?.length > 1 && (
          <>
            {user.brandList.map((brand, idx) => (
              <Menu.Item
                key={`brand_list_by_user_` + idx}
                className={
                  user &&
                  user.representative_brand_id &&
                  user.representative_brand_id === brand.id
                    ? "representative-brand"
                    : ""
                }
              >
                {brand.brand_name}
              </Menu.Item>
            ))}
          </>
        )}
    </Menu>
  );

  const logout = async () => {
    if (window.confirm("정말 로그아웃 하시겠습니까?")) {
      setIsLoading(true);
      const param = {
        id: user.id === 724 ? 1 : user.id,
      };
      await userAuthApi.logout(param);
      dispatch(setUser(null));
      dispatch(setMenu([]));
      setIsLoading(false);
      history.push(`/`);
    }
  };

  const showModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchKeyword(value);
  };

  return (
    <Row
      justify="end"
      align="middle"
      style={{ height: 55, position: "relative", gap: "16px 16px" }}
    >
      <img
        className="call-purchase"
        onClick={() => {
          history.push(`/salesManage/order/create`);
        }}
        src={`${process.env.REACT_APP_HOST}/assets/images/call-purchase-icon.png`}
      />
      {user &&
      user.role !== "super_admin" &&
      user.brandList &&
      user.brandList?.length > 1 ? (
        <Dropdown
          overlay={brandList}
          trigger={["click"]}
          className={`brand-list-dropdown-title cursor-pointer not-drag`}
          overlayClassName="brand-list-dropdown"
          onVisibleChange={(visible) => {
            setDropdownVisible(visible);
          }}
        >
          <div>
            <span>{user.nickname} 님</span>
            <img
              src={`${process.env.REACT_APP_HOST}/assets/images/dropdown-icon-${
                dropdownVisible ? "up" : "down"
              }.png`}
            />
          </div>
        </Dropdown>
      ) : (
        <span className="not-drag">{user.nickname} 님</span>
      )}
      <div className="logout-btn cursor-pointer" onClick={logout}>
        로그아웃
      </div>
      <Button className={`header-helper-button`} onClick={showModal}>
        도움말
      </Button>

      {/* 도움말 */}
      {isModalOpen && (
        <div className={`header-helper-wrap`}>
          <div className={`helper-header`}>
            <div className={`header-title`}>
              <div className={`title-div`}>
                <h3>도움말</h3>
                {/*<Button className={`faq-add-button`}>*/}
                {/*    <img*/}
                {/*        alt={"추가하기 버튼"}*/}
                {/*        src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/plus.png`}*/}
                {/*    />*/}
                {/*    추가하기*/}
                {/*</Button>*/}
              </div>
              <img
                onClick={showModal}
                className={`close-button`}
                alt={"닫기 버튼"}
                src={`${process.env.REACT_APP_HOST}/assets/images/memberManage/close-white.png`}
              />
            </div>
            <Form.Item className="header-search">
              <Input.Search
                name="product_name"
                id="search-input"
                value={searchKeyword}
                onChange={handleChange}
                placeholder={`키워드 검색`}
              />
              {searchKeyword?.length > 0 && (
                <img
                  onClick={() => setSearchKeyword("")}
                  className={`delete-button`}
                  alt={"닫기 버튼"}
                  src={`${process.env.REACT_APP_HOST}/assets/images/memberManage/delete.png`}
                />
              )}
            </Form.Item>
          </div>

          <div className={`helper-body`}>
            <FaqComponent
              searchKeyword={searchKeyword}
              setSearchKeyword={setSearchKeyword}
            />
          </div>
        </div>
      )}
    </Row>
  );
};

export default HeaderComponent;
